import { IconSvg, IconSvgProps } from "./icon"

export default function Ellipsis(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M18.429 13.929a1.929 1.929 0 1 0 0-3.858 1.929 1.929 0 0 0 0 3.858ZM12 13.929a1.929 1.929 0 1 0 0-3.858 1.929 1.929 0 0 0 0 3.858ZM5.571 13.929a1.929 1.929 0 1 0 0-3.858 1.929 1.929 0 0 0 0 3.858Z"
        fill="currentColor"
        stroke="none"
      />
    </IconSvg>
  )
}
